import {
  CheckboxSquarePrimaryCheckedIcon,
  CheckboxSquarePrimaryPartialIcon,
  CheckboxSquarePrimaryUncheckedIcon,
  TrashCanGray300Icon,
  TrashCanPrimaryIcon
} from '@assets/iconComponents';
import {
  AdminNavigation,
  AdminMenuTop,
  Pagination,
  SecureImage,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderItem,
  TableRow,
  TableWrapper,
  Text,
  GuideModal
} from '@components';
import {
  HorizontalAngleChildOptionValueEnum,
  VerticalAngleChildOptionValueEnum,
  AgeRangeChildOptionValueEnum,
  MainMotionPartChildOptionValueEnum,
  PostureCategoryChildOptionValueEnum,
  StandardFacialExpressionChildOptionValueEnum,
  styleConstant,
  StandardShotChildOptionValueEnum
} from '@constant';
import { useAdminImageList } from '@hooks';
import { Button } from '@mui/material';
import { colorSet } from '@theme';
import { getEnumKeyByValue } from '@utils';

const StandardImageListPage = () => {
  const {
    handleImageUploadButtonClick,
    handleTableRowClick,
    tableHeader,
    response,
    page,
    handlePageChange,
    checkedItems,
    getHeaderCheckboxState,
    handleHeaderCheckboxClick,
    handleRowCheckboxClick,
    isDeleteModalVisible,
    handleDeleteButtonClick,
    handleDeleteModalClose,
    handleImageDeleteConfirm,
    isPending
  } = useAdminImageList();

  return (
    <>
      <AdminMenuTop />

      <div style={{ display: 'flex' }}>
        <AdminNavigation />

        <div
          className="hide-scrollbar"
          style={{
            width: '100%',
            height: `calc(100vh - ${styleConstant.menuTopHeight}px)`,
            padding: '48px 40px 96px 40px',
            overflowY: 'auto'
          }}
        >
          <Text variant="h2" fontWeight="bold" marginBottom="40px">
            스탠다드 검색 이미지 리스트
          </Text>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '32px'
            }}
          >
            <Button
              disabled={checkedItems.size === 0}
              onClick={handleDeleteButtonClick}
              variant="outlined"
              color="primary"
              style={{ width: 84, height: 44 }}
            >
              {checkedItems.size === 0 ? (
                <TrashCanGray300Icon style={{ width: 20, height: 20 }} />
              ) : (
                <TrashCanPrimaryIcon style={{ width: 20, height: 20 }} />
              )}
            </Button>
            <Button variant="contained" color="primary" onClick={handleImageUploadButtonClick}>
              이미지 업로드
            </Button>
          </div>

          <TableWrapper width="100%">
            <Table width="100%">
              <TableHeader>
                {tableHeader().length === 17
                  ? tableHeader().map((header, key) => (
                      <TableHeaderItem key={key} width={header.width}>
                        {header.id === 'checkbox' ? (
                          <div onClick={handleHeaderCheckboxClick} style={{ cursor: 'pointer' }}>
                            {getHeaderCheckboxState() === 'unchecked' && (
                              <CheckboxSquarePrimaryUncheckedIcon style={{ marginRight: '0px' }} />
                            )}
                            {getHeaderCheckboxState() === 'partial' && (
                              <CheckboxSquarePrimaryPartialIcon style={{ marginRight: '0px' }} />
                            )}
                            {getHeaderCheckboxState() === 'checked' && (
                              <CheckboxSquarePrimaryCheckedIcon style={{ marginRight: '0px' }} />
                            )}
                          </div>
                        ) : (
                          <Text color="white" fontWeight="bold" align="center">
                            {header.label}
                          </Text>
                        )}
                      </TableHeaderItem>
                    ))
                  : null}
              </TableHeader>
              <TableBody>
                {response?.data && response?.data.length > 0 && tableHeader().length === 17
                  ? response.data.map((row, key) => (
                      <TableRow
                        key={key}
                        onClick={() => {
                          handleTableRowClick(row.id, row.sequence?.id);
                        }}
                        style={{ cursor: 'pointer' }}
                        hideBorderBottom={Boolean(
                          response.data[key].sequence &&
                            response.data[key + 1] &&
                            response.data[key + 1].sequence &&
                            response.data[key].sequence?.id === response.data[key + 1].sequence?.id
                        )}
                      >
                        <TableCell
                          width={tableHeader()[0].width}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRowCheckboxClick(row.id);
                          }}
                        >
                          <div style={{ cursor: 'pointer' }}>
                            {checkedItems.has(row.id) ? (
                              <CheckboxSquarePrimaryCheckedIcon style={{ marginRight: '0px' }} />
                            ) : (
                              <CheckboxSquarePrimaryUncheckedIcon style={{ marginRight: '0px' }} />
                            )}
                          </div>
                        </TableCell>
                        <TableCell width={tableHeader()[1].width}>
                          <Text align="center">{row.sequence?.id ? `${row.id}-${row.sequence.id}` : row.id}</Text>
                        </TableCell>
                        <TableCell width={tableHeader()[2].width} padding="8px 12px">
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <div
                              style={{
                                width: 42,
                                height: 56,
                                border: `1px solid ${colorSet.gray300}`,
                                borderRadius: '3px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginRight: '12px'
                              }}
                            >
                              <SecureImage
                                imageUrl={row.s3Url ?? ''}
                                imageStyle={{ width: 34, height: 48, objectFit: 'contain' }}
                              />
                            </div>
                            <div
                              style={{
                                width: tableHeader()[2].width - 78,
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'flex-start'
                              }}
                            >
                              <Text
                                align="left"
                                style={{
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  width: '100%'
                                }}
                              >
                                {row.name}
                              </Text>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell width={tableHeader()[3].width} padding="16px 12px" justifyContent="flex-start">
                          <Text align="left">{row.comic?.genre}</Text>
                        </TableCell>
                        <TableCell width={tableHeader()[4].width} padding="16px 12px" justifyContent="flex-start">
                          <Text align="left">{row.imageOptionValue['배경컷'] ? '해당' : '미해당'}</Text>
                        </TableCell>
                        <TableCell width={tableHeader()[5].width} padding="16px 12px" justifyContent="flex-start">
                          <Text align="left" style={{ whiteSpace: 'pre-line' }}>
                            {row?.imageOptionValue['남성 인원수'] != null &&
                            row?.imageOptionValue['여성 인원수'] != null
                              ? `남자 ${row?.imageOptionValue['남성 인원수']}
                            여자 ${row?.imageOptionValue['여성 인원수']}`
                              : '-'}
                          </Text>
                        </TableCell>
                        <TableCell width={tableHeader()[6].width} padding="16px 12px" justifyContent="flex-start">
                          <Text align="left">
                            {getEnumKeyByValue(StandardShotChildOptionValueEnum, row.imageOptionValue['샷 구분'])}
                          </Text>
                        </TableCell>
                        <TableCell width={tableHeader()[7].width} padding="16px 12px" justifyContent="flex-start">
                          <Text align="left">{row.imageOptionValue['연출'] ? '해당' : '미해당'}</Text>
                        </TableCell>
                        <TableCell width={tableHeader()[8].width} padding="16px 12px" justifyContent="flex-start">
                          <Text align="left">
                            {getEnumKeyByValue(VerticalAngleChildOptionValueEnum, row.imageOptionValue['세로앵글'])}
                          </Text>
                        </TableCell>
                        <TableCell width={tableHeader()[9].width} padding="16px 12px" justifyContent="flex-start">
                          <Text
                            align="left"
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: '2',
                              WebkitBoxOrient: 'vertical',
                              wordBreak: 'break-all'
                            }}
                          >
                            {getEnumKeyByValue(AgeRangeChildOptionValueEnum, row.imageOptionValue['연령대']) ?? '-'}
                          </Text>
                        </TableCell>
                        <TableCell width={tableHeader()[10].width} padding="16px 12px" justifyContent="flex-start">
                          <Text
                            align="left"
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: '2',
                              WebkitBoxOrient: 'vertical',
                              wordBreak: 'break-all'
                            }}
                          >
                            {getEnumKeyByValue(
                              MainMotionPartChildOptionValueEnum,
                              row.imageOptionValue['중심동작부위']
                            ) ?? '-'}
                          </Text>
                        </TableCell>
                        <TableCell width={tableHeader()[11].width} padding="16px 12px" justifyContent="flex-start">
                          <Text
                            align="left"
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: '2',
                              WebkitBoxOrient: 'vertical',
                              wordBreak: 'break-all'
                            }}
                          >
                            {getEnumKeyByValue(
                              StandardFacialExpressionChildOptionValueEnum,
                              row.imageOptionValue['표정']
                            ) ?? '-'}
                          </Text>
                        </TableCell>
                        <TableCell width={tableHeader()[12].width} padding="16px 12px" justifyContent="flex-start">
                          <Text align="left">
                            {row.imageOptionValue['데포르메 여부'] === undefined
                              ? '-'
                              : row.imageOptionValue['데포르메 여부']
                                ? '해당'
                                : '미해당'}
                          </Text>
                        </TableCell>
                        <TableCell width={tableHeader()[13].width} padding="16px 12px" justifyContent="flex-start">
                          <Text
                            align="left"
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: '2',
                              WebkitBoxOrient: 'vertical',
                              wordBreak: 'break-all'
                            }}
                          >
                            {getEnumKeyByValue(HorizontalAngleChildOptionValueEnum, row.imageOptionValue['가로앵글']) ??
                              '-'}
                          </Text>
                        </TableCell>
                        <TableCell width={tableHeader()[14].width} padding="16px 12px" justifyContent="flex-start">
                          <Text
                            align="left"
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: '2',
                              WebkitBoxOrient: 'vertical',
                              wordBreak: 'break-all'
                            }}
                          >
                            {getEnumKeyByValue(PostureCategoryChildOptionValueEnum, row.imageOptionValue['동작구분']) ??
                              '-'}
                          </Text>
                        </TableCell>
                        <TableCell width={tableHeader()[15].width} padding="16px 12px" justifyContent="flex-start">
                          <Text align="left">
                            {row.imageOptionValue['스킨십'] === undefined
                              ? '-'
                              : row.imageOptionValue['스킨십']
                                ? '해당'
                                : '미해당'}
                          </Text>
                        </TableCell>
                        <TableCell width={tableHeader()[16].width} padding="16px 12px" justifyContent="flex-start">
                          <Text
                            align="left"
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: '2',
                              WebkitBoxOrient: 'vertical',
                              wordBreak: 'break-all'
                            }}
                          >
                            {row.tags
                              ? row.tags.map(
                                  (item, index) => `${item.name}${index === row.tags.length - 1 ? '' : ', '}`
                                )
                              : ''}
                          </Text>
                        </TableCell>
                      </TableRow>
                    ))
                  : []}
              </TableBody>
            </Table>
          </TableWrapper>

          <div
            style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end' }}
          >
            <div style={{ display: 'flex', flexDirection: 'row', gap: 8, alignItems: 'center' }}>
              <Text variant="body1">Total</Text>
              <Text variant="subtitle" fontWeight="bold">
                {response?.meta?.itemCount ?? 0}
              </Text>
            </div>
            <Pagination page={page} pageCount={response?.meta?.pageCount ?? 0} onChange={handlePageChange} />
          </div>
        </div>
      </div>

      <GuideModal
        isVisible={isDeleteModalVisible}
        onClick={handleImageDeleteConfirm}
        onClose={handleDeleteModalClose}
        title="이미지를 삭제하시겠습니까?"
        content="이미지 삭제는 REFA에 반영됩니다."
        buttonText="삭제하기"
        buttonCount={2}
        isPending={isPending}
      />
    </>
  );
};

export default StandardImageListPage;
